import { createSlice } from '@reduxjs/toolkit';

export interface DocumentStructureHelpModalState {
    isOpen: boolean;
}

const initialState: DocumentStructureHelpModalState = {
    isOpen: false,
};

export const documentStructureHelpModalSlice = createSlice({
    name: 'documentStructureHelpModal',
    initialState,
    reducers: {
        open(state: DocumentStructureHelpModalState) {
            // eslint-disable-next-line no-param-reassign
            state.isOpen = true;
        },
        close(state: DocumentStructureHelpModalState) {
            // eslint-disable-next-line no-param-reassign
            state.isOpen = false;
        },
    },
});

export const documentStructureHelpModalActions = documentStructureHelpModalSlice.actions;
export default documentStructureHelpModalSlice.reducer; 